import axios from '@/jslib/axios'

export const getCarbombList = (params,other) => {
  return axios({
    method: 'get',
    url: '/admin/roadbomb/list',
    params,
    ...other
  })
}
export const getCarbombDetail= params => {
  return axios({
    method: 'get',
    url: '/admin/roadbomb/detail',
    params
  })
}
export const addCarbombRemark= data => {
  return axios({
    method: 'post',
    url: '/admin/pv/renew/add/remark',
    data
  })
}
export const updateCarbombStatus= data => {
  return axios({
    method: 'post',
    url: '/admin/roadbomb/edit',
    data
  })
}
export const editCarbomb= data => {
  return axios({
    method: 'post',
    url: '/admin/roadbomb/edit',
    data
  })
}
export const weeklySortCarbomb= data => {
  return axios({
    method: 'post',
    url: '/admin/roadbomb/weekly/sort',
    data
  })
}
export const weeklyListCarbomb= params => {
  return axios({
    method: 'get',
    url: '/admin/roadbomb/weekly',
    params
  })
}
export const summaryCarbomb= params => {
  return axios({
    method: 'get',
    url: '/admin/roadbomb/summary',
    params
  })
}
